import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from 'src/contexts/AuthContext';
import LoadingState from 'src/components/admin/LoadingState';

export default function PrivateRoute({ component: Component, ...rest }) {
  const { isAuth, initializing } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (initializing) {
          return (
            <div className="flex h-full items-center justify-center p-8">
              <LoadingState rows={4} />
            </div>
          );
        }
        if (isAuth) {
          return <Component {...props} />;
        }
        return <Redirect to="/signin" />;
      }}
    />
  );
}
